import styled from 'styled-components'
import { Button, Text } from '@sketch/components'
import {
  IndexLayoutOldTitle,
  IndexLayoutOldSubtitle,
} from '@sketch/modules-common'

import { breakpoint } from '@sketch/global-styles'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  max-width: 472px;
  margin: 0 auto;
`

export const StyledButton = styled(Button)`
  margin: 0 0 16px;

  &:last-child {
    margin: 0;
  }

  > div {
    /* Prevent a long workspace name to appear cropped */
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    line-height: 1.2;
  }
`

export const StyledTitle = styled(IndexLayoutOldTitle)`
  margin: 0 0 19px; /* stylelint-disable-line scales/space */
`

export const StyledSubtitle = styled(IndexLayoutOldSubtitle)`
  font-size: 1rem;
  margin: 40px 0 0px; /* stylelint-disable-line scales/space */
  color: ${({ theme }) => theme.colors.foreground.secondary.B};

  ${breakpoint('sm')`
    font-size: 1.375rem;
    margin: 68px 0 0px;
  `};
`

export const WrapperMemberCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding: 16px 24px 16px 11px; /* stylelint-disable-line scales/space */
  margin-bottom: 24px;

  border-radius: ${({ theme }) => theme.radii.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.A};
  box-shadow: ${({ theme }) => theme.shadows.boxShadow.lifted};
  background: ${({ theme }) => theme.colors.background.secondary.A};
`

export const RoleText = styled(Text.Span).attrs({
  textStyle: 'copy.tertiary.standard.D',
})`
  margin-left: 16px;
  flex-shrink: 0;
`

export const InfoText = styled.span`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 16px;
`

export const DifferentAccountText = styled(Text.Span).attrs({
  textStyle: 'copy.tertiary.standard.D',
})`
  margin-bottom: 24px;
  text-align: center;

  > b {
    color: ${({ theme }) => theme.colors.foreground.secondary.B};
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin: 0 0 19px; /* stylelint-disable-line scales/space */

  height: 124px;
`

export const ArrowIconWrapper = styled.div`
  flex-shrink: 0;
  width: 29px;
  height: 29px;
  padding: 6px; /* stylelint-disable-line scales/space */
  color: ${({ theme }) => theme.colors.sketch.A};
  border-radius: 15px; /* stylelint-disable-line scales/radii */
  background: ${({ theme }) => theme.colors.sketch.F};
`
